module.exports = __webpack_public_path__ + "static/media/travel-products.dfa1fc22.png";